import client from './client';
import type { LoginResponse, User } from '../types';

export async function startAppleLogin(binding: string): Promise<string> {
  const response = await client.post('/apple-login/challenge', { platform: 'web', binding });
  const url = new URL(response.data.data?.authorizationURL);
  if (url.origin !== 'https://appleid.apple.com' || url.pathname !== '/auth/authorize') {
    throw new Error('Invalid Apple authorization URL');
  }
  return url.href;
}

export async function exchangeAppleLogin(code: string, verifier: string): Promise<LoginResponse> {
  const response = await client.post<LoginResponse>('/apple-login/exchange', { code, verifier });
  return response.data;
}

export interface SmsCodeSendResponse {
  code: number;
  message: string;
  data: {
    challengeId: string;
    phone: string;
    expiresIn: number;
    retryAfter: number;
  } | null;
}

// 用户登录
export async function login(identifier: string, password: string): Promise<LoginResponse> {
  const response = await client.post<LoginResponse>('/login', {
    identifier,
    password,
  });
  return response.data;
}

export async function loginWithGoogle(credential: string): Promise<LoginResponse> {
  const response = await client.post<LoginResponse>('/google-login', {
    credential,
  });
  return response.data;
}

export async function sendSmsCode(phone: string): Promise<SmsCodeSendResponse> {
  const response = await client.post<SmsCodeSendResponse>('/sms-code/send', {
    phone,
  });
  return response.data;
}

export async function loginWithSmsCode(challengeId: string, code: string): Promise<LoginResponse> {
  const response = await client.post<LoginResponse>('/sms-code/login', {
    challengeId,
    code,
  });
  return response.data;
}

// 验证 token 有效性
export async function verifyToken(): Promise<{ code: number; message: string; data: User | null }> {
  const response = await client.get('/verify-token');
  return response.data;
}

// 获取当前用户信息
export async function getUserInfo(): Promise<{ success: boolean; code: number; message: string; data: User | null }> {
  const response = await client.get('/user-info');
  return response.data;
}
